var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.83752 1.46229C10.0542 1.67893 10.0542 2.02888 9.83752 2.24552L8.821 3.26204L6.73795 1.179L7.75448 0.16247C7.85826 0.0584547 7.99916 0 8.14609 0C8.29302 0 8.43392 0.0584547 8.5377 0.16247L9.83752 1.46229ZM0 9.72226V8.0336C0 7.95584 0.0277738 7.88918 0.0833216 7.83363L6.14359 1.77336L8.22663 3.8564L2.16081 9.91668C2.11082 9.97223 2.03861 10 1.96639 10H0.277739C0.122205 10 0 9.87779 0 9.72226Z",
    fill: "#090909"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.3f84b8792e9845bd93bdfbedd9fd4d80.svg";
export { ForwardRef as ReactComponent };